import { image } from "../../../assets";

export const reviewsData = [
    {
        userName: "Alonso Campos",
        userType: "Frontend Developer",
        avatar: image.avatar01,
        comment:
            "Un curso excelente, el profesor explica detalladamente como funciona react native y también como hacer componente por componente, he buscado muchos cursos de react native pero ninguno me ha enseñado tanto como este, ahora estoy desarrollando mi propia aplicación sin ningún tipo de problema gracias al curso.",
    },
    {
        userName: "Valentina Rubio",
        userType: "FullStack Developer",
        avatar: image.avatar02,
        comment:
            "El contenido del curso es muy completo y de necesitar cualquier dato adicional el profesor está super pendiente para responderlo. Ya tengo creado mi E-commerce con WordPress y gran parte de la información necesaria la obtuve del curso.",
    },
    {
        userName: "David Ramiro",
        userType: "Backend Developer",
        avatar: image.avatar03,
        comment:
            "Si te gustan los cursos que profundizan en la materia, te lo recomiendo. El profesor explica de forma completa todos los conceptos necesarios para trabajar con grid. Un gran curso.",
    },
    {
        userName: "Marc Perez",
        userType: "UI/UX",
        avatar: image.avatar04,
        comment:
            "Empecé el curso sin saber nada de React Native y creo que lo finalizo teniendo un nivel de conocimiento como para embarcarme en realizar mi primera aplicación.",
    },
    {
        userName: "Jesus Cruz",
        userType: "Frontend Developer",
        avatar: image.avatar05,
        comment:
            "Me ha parecido un buen curso, las explicaciones muy claras y lo que enseña me ha sido muy útil para la aplicación que me habían encargado.",
    },
    {
        userName: "Francisco Garcia",
        userType: "FullStack Developer",
        avatar: image.avatar06,
        comment:
            "Aprendes todo lo que promete el video de inicio y te da la capacidad para después crear tus propias apps. Gracias Agus por crear este curso, tenes mucho talento para explicar y se nota que te encanta hacerlo.",
    },
];